var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.current_user)?_c('v-row',{attrs:{"justify":"center"}},[_c('v-btn',{attrs:{"large":""},on:{"click":_vm.internal_send_to_google}},[_vm._v(" Login")])],1):(!_vm.current_user.is_admin)?_c('v-row',[_c('v-col',[_vm._v(" You are not admin ")])],1):_c('admin-component')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }